import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FiPlus } from 'react-icons/fi';
import * as jwtDecode from 'jwt-decode';

import {
  Title,
  Button,
  WrapperFlex,
  Breadcrumbs,
} from '@unimed-fesp/components';

import { Creators as RelatorioActions } from '../../store/ducks/relatorio';
import history from '../../services/history';

// #region Import Componentes
import FadeIn from '../../components/atoms/FadeIn';
import Relatorios from '../../components/molecules/Relatorios';
import { ModalConfimarRelatorio } from '../../components/molecules/PartsModalRelatorioNestle';

import modal from '../../context/TriggerModalContext';
// #endregion

import theme from '../../styles/theme';
import { Container } from './styles';

import { legacyRoutes } from '../../routes/legacyRoutes';

const { REACT_APP_BASEURL } = process.env;

const RelatorioNestle = () => {
  const dispatch = useDispatch();
  const { data: relatorioAPI } = useSelector(
    (state) => state.relatorio.getUltimoRelatorioNestle
  );
  const { accessToken } = useSelector((state) => state.auth);

  const { GrupoContratante } = jwtDecode(accessToken);

  const EM_ANDAMENTO = 'Em andamento';
  const FINALIZADO = 'Finalizado';

  const downloadRelatorioNestle = useCallback((id) => {
    const a = document.createElement('a');
    a.href = `${REACT_APP_BASEURL}/relatorios/relatorio-beneficiario-nestle/${id}`;
    a.download = 'batatinha';
    a.setAttribute('target', '_blank');
    a.click();
  }, []);

  const relatorios = useMemo(
    () =>
      relatorioAPI
        ? [
            {
              ...relatorioAPI,
              status: relatorioAPI.finalizado ? FINALIZADO : EM_ANDAMENTO,
              urlDownload: () => {
                const id = (
                  relatorioAPI.reportRequest || ''
                ).toLocaleUpperCase();

                downloadRelatorioNestle(id);
              },
            },
          ]
        : [],
    [downloadRelatorioNestle, relatorioAPI]
  );

  const handleNovoRelatorio = useCallback(() => {
    const hasRelatorioEmAndamento = relatorios.some(
      (r) => r.status.toLocaleUpperCase() === EM_ANDAMENTO.toLocaleUpperCase()
    );

    if (hasRelatorioEmAndamento) {
      modal.warning('Existe um processo em execução para este usuário!');
    } else {
      modal.warning(
        <ModalConfimarRelatorio.BodyConfimarRelatorio />,
        () => {},
        ({ closeModal }) => (
          <ModalConfimarRelatorio.FooterConfimarRelatorio
            closeModal={closeModal}
            onClickOk={() => {
              const SEND_EMAIL = true;
              dispatch(RelatorioActions.postRelatorioNestleRequest(SEND_EMAIL));
              closeModal();
            }}
          />
        )
      );
    }
  }, [dispatch, relatorios]);

  useEffect(() => {
    if (GrupoContratante !== 'NESTLE') history.push('/novo/lista');
    else dispatch(RelatorioActions.getUltimoRelatorioNestleRequest());
  }, [GrupoContratante, dispatch]);

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="relatório de beneficiários"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />
            <WrapperFlex
              percentageWidth={30}
              justifyEnd
              alignCenter
              marginSides={10}
              flexWrap
              gap={10}
              marginRight={1}
            >
              <Button
                justifySpaceAround
                alignCenter
                font="16px unimed_slabregular"
                width={180}
                onClick={handleNovoRelatorio}
              >
                <FiPlus color={theme.white} size={20} />
                novo relatório
              </Button>
            </WrapperFlex>
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: 'relatório de beneficiários',
                onNavigate: () => history.push('/novo/relatorio-nestle'),
              },
            ]}
          />
        </WrapperFlex>
        <WrapperFlex marginTop={30} height={300}>
          <Relatorios
            relatorios={relatorios}
            handleNovoRelatorio={handleNovoRelatorio}
          />
        </WrapperFlex>
      </FadeIn>
    </Container>
  );
};

export default RelatorioNestle;
